import {Pipe, PipeTransform} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {TranslateService, Unit} from '@vdw/angular-component-library';
import {CalculateDimensionsBasePipe} from '../calculate-dimensions-base-pipe';

@Pipe({
  name: 'calculateRestLengthOfProductionSchedulePath'
})
export class CalculateRestLengthOfProductionSchedulePathPipe extends CalculateDimensionsBasePipe implements PipeTransform {
  public constructor(translate: TranslateService) {
    super(translate);
  }

  public transform(productionSchedulePath: ProductionSchedulePath, displayTechnicalUnit: boolean, commercialUnit: Unit, productionSchedule: ProductionSchedule): string {
    let dimension = 0;

    if (displayTechnicalUnit) {
      dimension = productionSchedule.getProductionScheduleLengthInPicks() - productionSchedulePath.totalLengthInPicks;
    } else {
      dimension = productionSchedule.getProductionScheduleLengthInMillimeters() - productionSchedulePath.totalLengthInMM;
    }

    return `${this.calculateDimensions(dimension, displayTechnicalUnit, commercialUnit)} ${this.getUnitLabel(displayTechnicalUnit, Unit.PICKS, commercialUnit)}`;
  }
}
